module.exports = __webpack_public_path__ + "static/media/DBKFoundryWorkshopA0009_design_clean_v002.58393c2a.png";